import NotificationsArchiveActionControllerBase from "./notifications-archive-action-controller-base";

export default class extends NotificationsArchiveActionControllerBase {
  get completeEventName() {
    return "archive-all-notifications:complete";
  }
};



// WEBPACK FOOTER //
// ./app/components/notifications/assets/javascript/notifications-archive-all-button-controller.js